import React from 'react'
import '../styles/Roadmap.css'
export default function Roadmap() {
    return (
        <div className='Roadmap_container'id="Roadmap_container">
            <h1>Project Roadmap</h1>
            <div className="timeline">
                <div className="container left">
                    <div className="content">
                        <h2>#Brew 1.0</h2>
                        <p>
                            <ul>
                                <li>first 10K NFTs  will be launched in this phase which have been already prepared.</li>
                                <li>
                                    Revealing the project on 24 March as scheduled
                                </li>
                                <li>
                                    510 unique NFTs will be launched on 24 March, then 490 on March 31st (well don't get fooled😉)
                                </li>
                                <li>
                                    Then every week 1k NFT launch as on 7th April, 14th April, 21st April & so on....
                                </li>
                                <li>
                                    70 days 10k NFT… 1k every weekend are you ready for a Bash every weekend
                                    Looks like a MacD meal every weekend, Ara Ara
                                </li>
                                <li>
                                    1% goes to UNICEF fund for children after all are kids betting millions on some monkeys xD 🙈
                                </li>
                                <li>
                                    Getting 10k followers on Instagram, Twitter & discord.
                                </li>
                                <li><h2>Growing community base.</h2></li>
                            </ul>
                        </p>
                    </div>
                </div>
                <div className="container right">
                    <div className="content">
                        <h2>#Brew 2.0</h2>
                        <p>
                            <ul>
                                <li>Incorporated 3d art to finest of details.</li>
                                <li>Customisable merchandise for special NFT  holders shipped all over the globe.</li>
                                <li>
                                    Revolutionary change in QR- using ar as an public extension for a music album, movie,documentary , digital record keeping and informative public directory, dictionaries and educational stuff.
                                </li>
                            </ul>
                        </p>
                    </div>
                </div>
                <div className="container left">
                    <div className="content">
                        <h2>#Brew 3.0</h2>
                        <p><ul >
                            Well it’s a long shot ahead who knows where we land meta or Mars.
                            Customised QR banners for companies in meta.
                            Revolutionary change in QR- using ar as an public extension for a music album, movie,documentary , digital record keeping and informative public directory, dictionaries and educational stuff.
                        </ul></p>
                    </div>
                </div>
                
               
               
            </div>
        </div>
    )
}
